import { company_name } from "@/i18n/variables";

const configurator = {
	backup: {
		description: `<strong>Standard-Backup</strong> 
			<ul>
				<li>Tägliches Backup, das 2 Tage aufbewahrt wird.</li>
				<li>Wöchentliches Backup, das 2 Wochen aufbewahrt wird.</li>
				<li>Monatliches Backup, das 1 Monat aufbewahrt wird.</li>
			</ul>
			
			<strong>Zusätzliches Backup</strong> 
			<ul>
				<li>4x tägliches Backup, von denen eines 7 Tage aufbewahrt wird.</li>
				<li>Wöchentliches Backup, das 4 Wochen aufbewahrt wird.</li>
				<li>Monatliches Backup, das 6 Monate aufbewahrt wird.</li>
			</ul>`,
		radio: {
			extra_backups: {
				label: "Zusätzliche Backups",
				tip: "Es wird 4x täglich ein Backup erstellt. Ein tägliches Backup wird 7 Tage lang aufbewahrt, ein wöchentliches Backup 4 Wochen lang und ein monatliches Backup 6 Monate lang.",
			},
			standard: {
				label: "Standard",
				tip: "Es wird einmal täglich ein Backup erstellt, das 2 Tage lang aufbewahrt wird. Ein wöchentliches Backup wird 2 Wochen lang aufbewahrt, und ein monatliches Backup wird 1 Monat lang aufbewahrt.",
			},
		},
		title: "Backup",
	},
	config_lower_then_template:
		"Der eingestellte Wert von {{label}} beträgt {{configuration_value}} {{unit_type}}, während das Betriebssystem mindestens {{template_value}} {{unit_type}} empfiehlt. Dies kann zu Leistungsproblemen führen.",
	configurator_overview: {
		cancel_concept_order_error:
			"Wir konnten den Entwurfsauftrag nicht stornieren. Bitte versuchen Sie es später noch einmal.",
		change_vps: "Ihren VPS ändern",
		confirm_new_vps: "Übersicht des neuen VPS",
		excl_vat: "Ohne MwSt.",
		form: {
			description: {
				label: "VPS-Beschreibung",
				placeholder: "Bemerkungen/Besonderheiten des VPS",
			},
			name: {
				label: "VPS-Name",
				placeholder: "",
			},
			purchase_order_number: {
				label: "Ihre Bestellnummer",
				placeholder: "Ihre eventuelle Bestellnummer",
			},
		},
		info: "Der Datenverkehr Ihres neuen VPS wird innerhalb Ihres Kontopools berechnet. Weitere Informationen finden Sie unter",
		license: "Lizenz",
		new_price: "Preis für die neue Konfiguration",
		new_vps: "Betriebssystem/Anwendung",
		old_price: "Sie haben bezahlt",
		price_total: "Gesamtpreis",
		vps_configuration: {
			description: "Übersicht Ihres neuen VPS.",
			title: "VPS-Konfiguration",
		},
		vps_details: {
			description: "Hier können Sie Änderungen vornehmen, wenn nötig.",
			title: "VPS-Details",
		},
		your_discount: "Ihr Rabatt",
		your_vps: "Betriebssystem/Anwendung",
	},
	details: {
		description:
			"Geben Sie dem VPS einen eindeutigen Namen (keine Sonderzeichen). Optional können Sie eine Beschreibung für den VPS hinzufügen.",
		inputs: {
			description: "VPS-Beschreibung",
			name: "VPS-Name",
		},
		title: "VPS-Name",
	},
	extra_storage: {
		bulk_storage: {
			description:
				"Dieser Speicher eignet sich hervorragend für Backup-Daten, Archivierung und Daten für nicht kritische Dienste. Von diesem Speicher werden <strong> keine Backups </strong> erstellt.",
			title: "Masse",
		},
		description:
			"Hier kann dem VPS zusätzlicher Speicherplatz für verschiedene Zwecke hinzugefügt werden. \n Wählen Sie den gewünschten Speicherort aus.",
		no_storage: "Kein Speicher",
		performance_storage: {
			description: "Hier muss noch ein Text erfunden werden!!! T.B.D",
			title: "Leistung",
		},
		title: "Zusätzlicher Speicherplatz",
	},
	footer: {
		actual_price: "Aktueller Preis",
		configuration_check: "Konfiguration überprüfen",
		configuration_price: "Konfigurationspreis",
		discount_price: "Ihr Preis",
		month: "Monat",
		order_title: "Befehlen",
	},
	internet: {
		description: {
			href: "https://www.tuxis.nl/de/network",
			text: "Wählen Sie zwischen <strong>IPv6</strong> oder <strong>IPv4 & IPv6</strong>.<br/>Nur der Datenverkehr, der das Tuxis-Netzwerk verlässt, wird von Ihrem Netzwerkpool abgezogen. Sie haben noch keinen Pool ausgewählt? Dann verwenden wir Option eins: 100 GB, wie unter <a>tuxis.nl/network</a> angegeben.",
		},
		radio: {
			ipv4: "Mit einer IPv4- und IPv6-Adresse",
			ipv6: "Nur mit einer IPv6-Adresse",
			no_internet: "Keine Internetverbindung",
		},
		title: "Internetverbindung",
	},
	private_networks: {
		description:
			"Verknüpfen Sie VPS miteinander über ein privates Netzwerk. Der VPS erhält dafür eine separate Netzwerkschnittstelle. VPS, die sich im selben Netzwerk befinden, können miteinander kommunizieren. Sie müssen nur IP-Adressen auf dieser internen Schnittstelle konfigurieren.",
		existing: {
			select: {
				label: "Privates Netzwerk",
				list: "Wählen Sie ein Netzwerk aus",
			},
			title: "Wählen Sie ein bestehendes privates Netzwerk aus",
		},
		new: {
			input: {
				description: "Netzwerkbeschreibung",
				name: "Netzwerkname",
			},
			title: "Neues privates Netzwerk",
		},
		radio: {
			existing_private_network: "Bestehendes privates Netzwerk",
			new_private_network: "Neues privates Netzwerk",
			no_private_network: {
				label: "Kein privates Netzwerk",
				tip: "Der VPS wird mit einer Internet-Schnittstelle geliefert, um auf das Internet zuzugreifen.",
			},
		},
		title: "Private Netzwerke",
	},
	sla: {
		description: {
			href: "https://tuxis.nl/de/sla",
			text: "Machen Sie aus Ihrem VPS ein vollständig verwaltetes VPS. Ein SLA - Level 1 überwacht rund um die Uhr die Systemgesundheit, und ein SLA - Level 2 überprüft sogar, ob Ihre Anwendung reagiert. Eine halbe Stunde Arbeit an diesem VPS ist enthalten, und Sie können auf garantierte Reaktionszeiten zählen. Weitere Informationen finden Sie unter <a>tuxis.nl/sla</a>.",
		},
		radio: {
			level_one: {
				label: "SLA - Level 1",
				tip: `<strong>SLA - Level 1</strong> 
					<ul>
						<li>Überwachung der Systemgesundheit</li>
						<li>Störungsbehebung beginnt innerhalb einer Stunde</li>
						<li>Monatliche Durchführung von Updates</li>
						<li>Wichtige Sicherheitsupdates sofort</li>
						<li>Halbe Stunde Arbeit an diesem VPS</li>
						<li>Rund um die Uhr Störungsbehebung</li>
					</ul>
				`,
			},
			level_two: {
				label: "SLA - Level 2",
				tip: `<strong>SLA - Level 2</strong> 
					<ul>
						<li>Überwachung der Systemgesundheit</li>
						<li>Störungsbehebung beginnt innerhalb einer Stunde</li>
						<li>Monatliche Durchführung von Updates</li>
						<li>Wichtige Sicherheitsupdates sofort</li>
						<li>Halbe Stunde Arbeit an diesem VPS</li>
						<li>Überwachung von Diensten und Ergebnissen</li>
						<li>Rund um die Uhr Störungsbehebung oder Ausfall von Diensten</li>
					</ul>
				`,
			},
			level_zero: {
				label: "SLA - Level 0",
			},
			no_sla: "Keine",
		},
		title: "Service Level Agreement",
	},
	snapshots: {
		description:
			"Snapshots sind nützlich, wenn Sie ein Update durchführen. Hier legen Sie fest, wie viele Snapshots Sie gleichzeitig speichern dürfen.",
		no_snapshots: {
			info: "Sie können diese Option nur wählen, wenn <strong>alle</strong> Snapshots gelöscht wurden.",
			label: "Keine",
		},
		select_amount: {
			info: "Es wurden <strong>{{snapshots}} {{multiple}}</strong> erstellt. Sie können also maximal auf <strong>{{snapshots}} {{multiple}}</strong> zurücksetzen.",
			label: "Snapshots",
		},
		title: "Snapshots",
	},
	specs: {
		cpu: {
			title: "CPU-Kerne",
		},
		info: "Für größere Konfigurationen kontaktieren Sie uns bitte.",
		license: "<span>Lizenz:</span> €{{price}} pro Monat",
		ram: {
			title: "Arbeitsspeicher",
		},
		ssd: {
			title: "SSD-Speicher",
			tooltip:
				"Ihre Daten werden in Echtzeit in drei Rechenzentren auf SSDs gespeichert. Je mehr CPU-Kerne Sie im VPS verwenden, desto höher ist die Anzahl der IOPS. LINK zu IOPS auf https://support.tuxis.nl/nl/knowledgebase/article/iops-vps.",
		},
		title: "VPS-Kapazität",
	},
	ssh: {
		add_engineer_keys: {
			no: "Nein",
			title: `Möchten Sie ${company_name} Zugriff auf Ihren VPS gewähren?`,
			yes: "Ja, Zugriff gewähren",
		},
		add_own_keys: {
			no: "Nein",
			success: "SSH-Schlüssel zu Ihrem Konto hinzugefügt",
			title: "Möchten Sie Ihre persönlichen öffentlichen SSH-Schlüssel verwenden?",
			yes: "Ja",
		},
		already_present:
			"SSH-Schlüssel nicht hinzugefügt: Der neue SSH-Schlüssel ist identisch mit einem bereits hinzugefügten SSH-Schlüssel.",
		description:
			"Wählen Sie aus, welche Benutzer Zugriff auf den VPS haben, oder fügen Sie manuell SSH-Schlüssel hinzu. Es wird dann kein Passwort erstellt.Es wird dann kein Passwort erstellt. Stellen Sie sicher, dass der SSH-Port erreichbar bleibt. Dieses Passwort finden Sie auf der VPS-Info-Seite, wo es 30 Tage lang angezeigt wird (speichern Sie dieses Passwort also sorgfältig!).",
		engineer_keys_obliged: `Da Sie ein SLA ausgewählt haben, muss ${company_name} Zugriff auf Ihren VPS haben.`,
		external_keys: "Möchten Sie zusätzliche SSH-Schlüssel von einer externen Partei hinzufügen?",
		no_own_keys_top: "Sie haben keine SSH-Keys zu Ihrem Konto hinzugefügt.",
		title: "VPS-Zugriff",
		user_ssh_keys: {
			no_users_found: "Keine Benutzer mit SSH-Keys gefunden.",
			title: "SSH-Schlüssel von anderen Benutzern hinzufügen",
			users: "Benutzer",
		},
	},
	template_items_disabled_message:
		"One or more configuration options for this VPS template have been disabled by Tuxis. These disabled configuration options cannot be modified.",
	title: "VPS Konfigurator",
};

export default configurator;
